// Tradução de códigos técnicos de auditoria (operation/action/table_name/field_name/event_type)
// para rótulos que fazem sentido pra quem lê, sem exigir conhecimento do valor literal salvo no
// banco (INSERT/UPDATE, 'view_stats', 'options_tipo_parceria' etc.). Compartilhado entre a tabela
// (Pages/Audit.jsx) e o modal de detalhes (AuditDetailsModal.jsx) para não duplicar os mapas.

export const OPERATION_LABELS = {
  INSERT: 'Criado',
  UPDATE: 'Editado',
  DELETE: 'Apagado'
};

export const ACTION_LABELS = {
  create: 'Criado',
  update: 'Editado',
  delete: 'Apagado',
  list: 'Listado',
  view_stats: 'Estatísticas Visualizadas',
  download_template: 'Template Baixado',
  import_excel: 'Importado via Excel',
  recalculate_statuses: 'Status Recalculados',
  bulk_create: 'Criado em Lote',
  list_tipos: 'Tipos Listados',
  list_tipo_parceria: 'Tipos de Parceria Listados',
  create_tipo_parceria: 'Tipo de Parceria Criado',
  list_origens: 'Origens Listadas',
  list_origem: 'Origens Listadas',
  create_origem: 'Origem Criada',
  list_prazos: 'Prazos Listados',
  create_prazo: 'Prazo Criado',
  generate_pdf: 'PDF Gerado',
  generate: 'Gerado',
  generate_template: 'Template Gerado',
  preview: 'Pré-visualizado',
  list_templates: 'Templates Listados',
  view_pool_stats: 'Estatísticas do Pool Visualizadas',
  view_logs: 'Logs Visualizados',
  view_login_history: 'Histórico de Login Visualizado',
  view_data_changes: 'Alterações de Dados Visualizadas',
  view_security_events: 'Eventos de Segurança Visualizados',
  export: 'Exportado',
  export_data: 'Dados Exportados',
  session_update: 'Sessão Atualizada',
  page_view: 'Visualização de Página',
  api_request: 'Requisição API'
};

export const TABLE_LABELS = {
  partnerships: 'Parcerias',
  users: 'Usuários',
  options_tipo_parceria: 'Tipos de Parceria',
  options_origem: 'Origens',
  options_prazos: 'Prazos'
};

export const FIELD_LABELS = {
  processo_ano: 'Processo/Ano',
  tipo_parceria: 'Tipo de Parceria',
  ano: 'Ano',
  origem: 'Origem',
  analises_observacoes: 'Análises e Observações',
  ug: 'Unidade Gestora',
  cnpj: 'CNPJ',
  osc: 'Nome da OSC',
  valor: 'Valor',
  data_inicio: 'Data de Início',
  data_fim: 'Data de Fim',
  prazos: 'Prazo (dias)',
  data_final_calculada: 'Data Final Calculada',
  local_f: 'Local do Documento',
  status: 'Status',
  name: 'Nome',
  email: 'E-mail',
  role: 'Perfil',
  is_active: 'Ativo',
  nome: 'Nome',
  dias: 'Dias',
  ativo: 'Ativo'
};

export const RESOURCE_TYPE_LABELS = {
  page: 'Página',
  api: 'API',
  user: 'Usuário',
  partnership: 'Parceria',
  'osc-declaration': 'Declaração OSC',
  'analytics-report': 'Relatório Analítico'
};

export const EVENT_TYPE_LABELS = {
  account_locked_login_attempt: 'Tentativa de Login em Conta Bloqueada',
  multiple_failed_logins: 'Múltiplas Tentativas de Login Falhas',
  refresh_token_reuse: 'Reuso de Token de Sessão Revogado',
  user_deleted: 'Usuário Deletado'
};

// Campos monetários exibidos nas caixas/colunas de valor — recebem máscara de moeda (R$) em vez
// do número cru salvo no banco (ex.: "15000.00" -> "R$ 15.000,00").
export const MONETARY_FIELDS = ['valor'];

const humanizeCode = (code) => {
  if (!code) return code;
  return String(code)
    .replace(/[_-]+/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

export const translateOperation = (operation) => OPERATION_LABELS[operation] || humanizeCode(operation);
export const translateAction = (action) => ACTION_LABELS[action] || ACTION_LABELS[action?.toLowerCase?.()] || humanizeCode(action);
export const translateTable = (tableName) => TABLE_LABELS[tableName] || humanizeCode(tableName);
export const translateResourceType = (resourceType) => RESOURCE_TYPE_LABELS[resourceType] || humanizeCode(resourceType);
export const translateField = (fieldName) => FIELD_LABELS[fieldName] || humanizeCode(fieldName);
export const translateEventType = (eventType) => EVENT_TYPE_LABELS[eventType] || humanizeCode(eventType);

export const formatChangeValue = (fieldName, rawValue, fallback) => {
  if (rawValue === null || rawValue === undefined || rawValue === '') return fallback;
  if (MONETARY_FIELDS.includes(fieldName)) {
    const numeric = Number(rawValue);
    if (!Number.isNaN(numeric)) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(numeric);
    }
  }
  return rawValue;
};
